import { setupMonitoring } from '~/monitoring.ts';

setupMonitoring();
